import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { PagamentoForm } from '../../../form/pagamento-form';
import { SezionePagamentiResponse } from '../../../models/dto/sezione-pagamenti-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Pagamento } from '../../../models/pagamento';
import { SezionePagamenti } from '../../../models/sezioni/sezione-pagamenti';

@Component({
    selector: 'div [pagamento-form-add]',
  templateUrl: '../../../form/pagamento-form.html'
})

export class PagamentiAddComponent extends PagamentoForm {
  idSezione: string;
  urlInsert: string;
  urlReadSezioneAltreParti: string;
  urlReadSezioneControparti: string;
  urlReadSezioneLegali: string;
  fascicolo: FascicoloFull;
  @Output() onReturn: EventEmitter<SezionePagamenti> = new EventEmitter<SezionePagamenti>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Pagamento');
    this.isInserimento(true);
  }

  getPagamento() {
    return new Pagamento();
  }

  getUrlReadSezioneAltreParti() {
    return this.urlReadSezioneAltreParti;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getRequest(pagamento: Pagamento) {
    this.operationService.addPagamento(this.urlInsert, pagamento, this.idSezione, this.fascicolo.id).subscribe((response: any) => this.datiPagamento(response));
  }

  datiPagamento(response: SezionePagamentiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string, fascicolo: FascicoloFull, urlInsert: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string, urlReadSezioneLegali: string) {
    this.idSezione = idSezione;
    this.urlInsert = urlInsert;
    this.fascicolo = fascicolo;
    this.urlReadSezioneAltreParti = urlReadSezioneAltreParti;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.createForm();
    if (this.sections.altreParti && this.sections.controparti && this.sections.legali) {
      this.populateSelect();
    } else {
      this.beneficiariAll = [];
      this.readSezioneAltreParti(fascicolo.idSezioneAltreParti);
      this.readSezioneControparti(fascicolo.idSezioneControparti);
      this.readSezioneLegali(fascicolo.idSezioneLegali);
    }
  }
}
